module.exports = __webpack_public_path__ + "static/media/undraw_loading.5c81aa02.svg";